import { openEreader } from 'a/eReader/redux/actions/ereader';
import {
  SEARCHLIGHT_EVENT_TYPE,
  DESTINATION_GROUP,
  NAVIGATION_ORIGIN,
  NAVIGATION_TRIGGER_TYPE,
} from 'root/lib/SearchlightDispatcher';
import { GAME_MODE, DEEP_LINK_GAME_MODE } from 'root/lib/constants';
import GameIds from 'a/hub/data/GameIds';
import { initAssignmentMode } from 'a/hub/actions/assignmentLinkActions';
import STEP_TYPE from 'a/hub/data/StepTypes';
import goToActivity from 'a/actions/navigationActions';
import { adjustLevels } from './utilityFunctions';

const handleDeepLinkParams = (config = {}) => async (dispatch) => {
  if (!Object.keys(config).length) {
    return false;
  }
  // Assignment links will have an assignmentId in url
  const urlParams = new URLSearchParams(window.location.search);
  const assignmentId = urlParams.get('assignmentId');

  const navigationParams = {
    origin: NAVIGATION_ORIGIN.DEEPLINK,
    trigger: 'login',
    triggerType: NAVIGATION_TRIGGER_TYPE.AUTOMATIC,
  };
  const commonParams = {
    isLink: true,
    deepLinkProgram: config.program,
    deepLinkMode: config.mode,
    extras: {
      // extra params for reporting or other purposes
      ...config.extra,
    },
    deepLinkConfig: config,
    ...(assignmentId && { assignmentId }),
  };

  if (config.type === STEP_TYPE.GAME) {
    if (config.name) {
      navigationParams.destinationGroup = DESTINATION_GROUP.GAME;
      const levels = adjustLevels(config.linkLevels);
      if (DEEP_LINK_GAME_MODE[config.mode] === GAME_MODE.ASSIGNMENT_LINK && assignmentId) {
        dispatch(initAssignmentMode({
          assignmentId,
          gameId: config.name,
          type: config.type,
          levels,
        }));
      }
      dispatch(goToActivity({
        activityName: config.name,
        navigationParams,
        params: {
          ...commonParams,
          linkLevels: levels,
        },
      }));

      dispatch({
        gameId: GameIds.METAGAME,
        type: 'SEARCHLIGHT_DISPATCH_EVENT',
        payload: {
          gameId: GameIds.METAGAME,
          application: {
            gameId: config.name.replace(/_(es|ela)$/, ''),
            eventType: SEARCHLIGHT_EVENT_TYPE.MINIGAME_LAUNCHED,
            details: { isQuestWorkflow: false },
          },
        },
      });
      return true;
    }
  }
  if (config.type === STEP_TYPE.EREADER) {
    const launchEreader = async (bookId, chapter) => {
      navigationParams.destination = bookId;
      navigationParams.destinationGroup = DESTINATION_GROUP.EREADER;
      dispatch(openEreader({
        navigationParams,
        params: {
          ...commonParams,
          chapter,
        },
        questId: 0,
        bookInfo: {
          bookGameId: bookId,
          chapter: chapter || '',
        },
      }));
    };
    await launchEreader(config.name, config.chapter);
    return true;
  }
  return false;
};

export default handleDeepLinkParams;
